import { ToggleButton, ToggleButtonGroup } from "~/common/mui";
import { styled } from "@mui/system";
import { useTranslation } from "react-i18next";
import { C_ON_SECONDARY_CONTAINER, C_OUTLINE, C_SECONDARY_CONTAINER } from "~/common/components/icon/Colors";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

interface Props {
  className?: string;
  disabled?: boolean;
  value: number;
  onChange: (value: number) => void;
}

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  ...getFontStyle(FontSize.LabelLarge),
  borderRadius: "28px",
  border: `1px solid ${C_OUTLINE}`,
  "&.Mui-selected": {
    backgroundColor: C_SECONDARY_CONTAINER,
    color: C_ON_SECONDARY_CONTAINER,
  },
}));

const radiusDropdownMetricValues = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "500", value: 500 },
  { label: "\u221E", value: -1 },
];

const radiusDropdownImperialValues = [
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
  { label: "100", value: 100 },
  { label: "500", value: 500 },
  { label: "\u221E", value: -1 },
];

export const RadiusSelectButtonGroup = ({ className, disabled, value, onChange }: Props) => {
  const { t } = useTranslation();
  const useImperial = window.SCHA.config.isSPFImperial;

  const radiusDropdownValues = useImperial ? radiusDropdownImperialValues : radiusDropdownMetricValues;

  return (
    <>
      <div className="f-label-color mt-2 mb-2">{t("partnerFinder.filter.radius")}</div>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={(event, newValue) => {
          if (newValue !== null) {
            onChange(newValue);
          }
        }}
        fullWidth
      >
        {radiusDropdownValues.map((radius) => (
          <StyledToggleButton key={radius.value} value={radius.value} disabled={disabled}>
            {radius.label}
          </StyledToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};
